import PublishersService from 'respona_api/generated/order-publisher_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): PublishersService.PublisherApiServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new PublishersService.PublisherApiServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
